import { loginByLineApi } from 'api/auth'
import { login, setTrustDevice } from 'redux/auth/slice'
import errorHandler from 'utils/errorHandler'
import { memberInfoApi } from 'api/member'
import handleBindingPhone from 'utils/auth/handleBindingPhone'
import handleNeedBindTrustDevice from 'utils/auth/handleNeedBindTrustDevice'
import checkIsCoolingPeriod from 'utils/checkIsCoolingPeriod'

export default payload => async (dispatch) => {
  try {
    await dispatch(setTrustDevice({ loginType: 'LINE' }))
    const result = await loginByLineApi(payload)
    if (result && result.needBindTrustDevice) {
      await handleNeedBindTrustDevice(result)
    } else {
      await dispatch(login())
      const memberInfoData = await memberInfoApi()
      await handleBindingPhone(memberInfoData, dispatch)
      checkIsCoolingPeriod(result)
    }
  } catch (error) {
    errorHandler(error)
  }
}
